import { render, staticRenderFns } from "./FacilitiesForm.vue?vue&type=template&id=3af31157&"
import script from "./FacilitiesForm.vue?vue&type=script&lang=js&"
export * from "./FacilitiesForm.vue?vue&type=script&lang=js&"
import style0 from "./FacilitiesForm.vue?vue&type=style&index=0&id=3af31157&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports